import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {LayoutModule} from '../../layout-components/layout.module';
import {ModalModule} from '@components/modal/modal.module';
import {FilePreviewModule} from '@components/file-preview/file-preview.module';
import {TabsModule} from '@components/tabs/tabs.module';
import {FormHelperService} from '@services/form-helper.service';
import {RouterModule} from '@angular/router';
import {DirectivesModule} from '@helpers/directives/directives.module';

/**
 * Собирает в себе и экспортирует (расширивает дригим модулям, поэтому и shared) частоиспользуемые общие модули.
 */

@NgModule({
    imports: [],
    exports: [
        ReactiveFormsModule,
        CommonModule,
        FormFieldModule,
        LayoutModule,
        ModalModule,
        FilePreviewModule,
        TabsModule,
        RouterModule,
        DirectivesModule,
    ],
    declarations: [],
    providers: [
        FormHelperService,
    ],
})
export class SharedModule {
}
